// Section5.jsx
import React, { useEffect, useRef, useState } from 'react';
const servicesBanner = "../assets/Custom Mobile Application Development.webp";


const useReveal = () => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0.12 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return [ref, visible];
};

const Section9 = () => {
  const solutions = [
    "Customer-facing mobile apps",
    "Enterprise mobile applications",
    "Employee productivity tools",
    "Booking and scheduling systems",
    "Marketplace platforms",
    "Subscription-based applications",
    "Membership and community platforms",
    "On-demand service applications",
    "SaaS companion apps"
  ];

  const scalability = ["Modular architecture", "Cloud integration", "API-first development", "Performance optimization", "Flexible infrastructure", "Future-ready technology stacks"];
  const ux = ["Intuitive navigation", "Fast performance", "Accessibility", "Consistent branding", "Engagement-focused design", "Seamless customer journeys"];

  const [bannerRef, bannerVisible] = useReveal();
  const [solRef, solVisible] = useReveal();

  return (
    <section id="custom-development" className="bg-white py-10">
      {/* Banner */}
      <div
        ref={bannerRef}
        className="relative h-[340px] bg-gradient-to-br from-[#cd2122] via-[#b91d1f] to-[#7a1314] flex items-center overflow-hidden"
      >
        <div
          className="pointer-events-none absolute inset-0 opacity-10"
          style={{ backgroundImage: 'radial-gradient(#fff 1px, transparent 1px)', backgroundSize: '24px 24px' }}
        />
        <div
          className={`max-w-7xl mx-auto text-center px-[10px] relative z-10 transition-all duration-700 ${
            bannerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <div className="max-w-2xl">
            <span className="inline-block text-white/80 text-xs font-semibold uppercase tracking-widest mb-3">Tailor-Made Solutions</span>
            <h2 className="text-white text-[32px] md:text-[38px] leading-tight font-extrabold mb-5">
              Custom Mobile Application Development
            </h2>
            <p className="text-white/90 text-[17px]">
              Every business has unique requirements. We build tailor-made mobile apps that perfectly align with your goals.
            </p>
          </div>
        </div>
        <div className="absolute right-0 bottom-0 w-1/2 h-full bg-[radial-gradient(circle_at_center,#ffffff15_0%,transparent_70%)]" />
      </div>

      <div className="max-w-7xl mx-auto px-6 -mt-10 relative z-1">
        <div className="bg-white rounded-3xl shadow-xl border border-gray-100 p-5 md:p-10">
          <p className="text-[#535353] text-[16px] leading-relaxed mb-2 max-w-100">
            Off-the-shelf solutions often limit flexibility, scalability, and competitive advantage. Our custom mobile app development method makes sure your app fits your goals. It aligns with your business needs.
          </p>
          <p className="text-[#535353] text-[16px] leading-relaxed mb-12 max-w-3xl">We create mobile apps customized for your workflows, customers, and operational needs.</p>

          <h3 className="text-2xl font-bold text-[#1a1a1a] mb-5">Custom Solutions We Develop</h3>
          <div className="flex flex-col-reverse md:flex-row gap-5 py-0 md:py-5">
          <div
            ref={solRef}
            className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mb-14"
          >
            {solutions.map((item, i) => (
              <div
                key={i}
                style={{ transitionDelay: `${i * 60}ms` }}
                className={`p-4 text-[12px] border border-gray-100 hover:border-[#cd2122] rounded-2xl transition-all duration-500 hover:shadow-lg hover:-translate-y-1 group ${
                  solVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
                }`}
              >
                <p className="text-[#535353] text-[12px] font-medium group-hover:text-[#cd2122] transition-colors">{item}</p>
              </div>
            ))}
          </div>
          <div><img src={servicesBanner} alt="" className='rounded-[2rem]' /></div>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-gradient-to-br from-[#fafafa] to-white p-9 rounded-3xl border border-gray-100">
              <h4 className="text-xl font-bold text-[#1a1a1a] mb-5">Built for Scalability</h4>
              <p className="text-[#535353] text-[16px] mb-2">A successful mobile application should grow alongside your business.</p>
              <p className="text-[#535353] text-[16px] mb-7">Our custom development solutions feature:</p>
              <ul className="space-y-3">
                {scalability.map((item, i) => (
                  <li key={i} className="flex gap-3 text-[16px] text-[#535353]">
                    <span className="text-[#cd2122] font-bold">→</span> {item}
                  </li>
                ))}
              </ul>
              <p className="text-[#535353] text-[16px] mt-5">This keeps your mobile app reliable and scalable as more users join.</p>
            </div>

            <div className="bg-gradient-to-br from-[#fafafa] to-white p-9 rounded-3xl border border-gray-100">
              <h4 className="text-xl font-bold text-[#1a1a1a] mb-5">User-Centric Experiences</h4>
              <p className="text-[#535353] text-[16px] mb-2">Successful applications are built around users.</p>
              <p className="text-[#535353] text-[16px] mb-7">We focus on:</p>
              <ul className="space-y-3">
                {ux.map((item, i) => (
                  <li key={i} className="flex gap-3 text-[16px] text-[#535353]">
                    <span className="text-[#cd2122] font-bold">→</span> {item}
                  </li>
                ))}
              </ul>
              <p className="text-[#535353] text-[16px] mt-5">The result is a mobile experience that encourages adoption, retention, and customer satisfaction.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section9;